import Vue from 'vue';
import { toCookie, toLocal } from './storages';
var moment = require('moment');

const store = {
    token: null,
    user: null,
    employees: [],
    period: 'week',
    showMenu: false,
    store: null,
    dates: null,
    graph_type: 'accumulated',
    //STOCK
    stock_categories:{},
    currentProduct:false
};

toLocal(store);

const state = Vue.observable(store);

const actions = {
    setToken(token) {
        state.token = token;
    },
    setUser(user) {
        state.user = user;
    },
    resetAuth() {
        state.token = null;
        state.user = null;
    },
    setEmployees(employees) {
        state.employees = employees;
    },
    setPeriod(period){
        if(period == 'custom'){
            state.dates = {
                start: moment().subtract('days', 7).format('YYYY-MM-DD'),
                end: moment().format('YYYY-MM-DD')
            }
        }
        state.period = period;
    },
    setShowMenu(showMenu){
        state.showMenu = showMenu
    },
    setStore(store){
        state.store = store
    },
    setDates(dates){
        state.dates = dates
    },
    setGraphType(graph_type){
        state.graph_type = graph_type
    },
    setStockCategories(stock_categories){
        state.stock_categories = stock_categories
    },
    openProduct(product){
        if(product){
            state.currentProduct = product
        } else {
            state.currentProduct = false
        }
    }

};

export {
state,
    actions
};